<template>
    <DashboardLayout>

        <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
            <p class="mb-0 main-identifier fw-semibold">Appraisal</p>
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
            <p class="mb-0 sub-identifier">Assign Authority to M.D.A.</p>
        </div>

        <div class="d-flex justify-content-center">

            <div style="max-width: 700px; width:100%;" class="form-outer">
                <form @submit.prevent="handleSubmit">
                    <div class="crud-form position-relative">

                        <div class="form-inner">
                            <div class="form-header d-flex justify-content-between align-items-center">
                                <h4>Assign Approval Authority to M.D.A.</h4>
                                <button type="button" class="form-close-button" @click="handleClose">
                                    &times;
                                </button>
                            </div>

                            <div class="row mb-3">
                                <div class="col-md-12 row form-group position-relative floating-label-group">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="mda" class="form-label">M.D.A</label></div>
                                  <div class="col-md-9 input-right">
                                        <select class="form-select" v-model="mdaName" required>
                                            <option value="" disabled>- Select MDA -</option>
                                            <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                                        </select>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="approval-authority" class="form-label">Approval Authority</label></div>
                                  <div class="col-md-9 input-right">
                                        <select class="form-select" v-model="approvalAuthorityName" required>
                                            <option value="" disabled>- Select Approval Authority -</option>
                                            <option v-for="approvalAuthority in approvalAuthorities" :key="approvalAuthority.id" :value="approvalAuthority.id">{{ approvalAuthority.name }}</option>
                                        </select>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="approval-authority-preferred-name" class="form-label">Approval Authority Preferred Name</label></div>
                                    <div class="col-md-9 input-right">
                                      <div class="col-md-12 input-right">
                                        <input type="text" class="form-control" v-model="preferredName" placeholder="" required>
                                      </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 row form-group position-relative floating-label-group">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="occupier" class="form-label">Occupier</label></div>
                                  <div class="col-md-9 input-right">
                                        <select class="form-select" v-model="occupier" required>
                                            <option value="" disabled>- Select Occupier -</option>
                                            <option v-for="occupier in occupiers" :key="occupier.id" :value="occupier.id">{{ occupier.name }}</option>
                                        </select>
                                  </div>
                                </div>

                            <div class="d-flex justify-content-center ">
                                <button class="submit-btn" type="submit" >Submit</button>
                            </div>
                        </div>


                    </div>
                </form>
            </div>
        </div>

    </DashboardLayout>
</template>

<script setup>
import {ref, reactive, onMounted } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const mdaName = ref('');
const approvalAuthorityName = ref('');
const preferredName = ref('');
const occupier = ref('');

// Reactive form data
const form = reactive({
  mdaName: '',
  approvalAuthorityName: '',
  preferredName: '',
  occupier: '',
})

const mdas = ref([]);
const approvalAuthorities = ref([]);
const occupiers = ref([]);

const fetchMDAs = async () => {
    const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch mdas:', error)
  }
}

const fetchApprovalAuthorities = async () => {
    const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/app-auth`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    approvalAuthorities.value = response.data.map(approvalAuthority => ({
      id: approvalAuthority.id,
      name: approvalAuthority.name,
    }))

  } catch (error) {
    console.error('Failed to fetch approval authorities:', error)
  }
}

const fetchOccupiers = async () => {
    const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/occupier`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    occupiers.value = response.data.map(occupier => ({
      id: occupier.id,
      name: occupier.name,
    }))

  } catch (error) {
    console.error('Failed to fetch occupiers:', error)
  }
}

const handleSubmit = async () => {
  try {
    const result = await axios.post(`${root_api_url}/eli/mda`, {
      mdaId: form.mdaName,
      orgCode: form.organizationCode,
      economicLineItemId: form.economicLineItemId
    })

    if (result.status === 201) {
      alert(`Approval Authority Assigned:\nApproval Authority Name: ${form.approvalAuthorityName}\n assigned to \nMda Name: ${form.mdaName}\n with \nPreferred Name: ${form.preferredName}\n and \nOccupier: ${form.occupier}`)
      form.mdaName = '';
      form.approvalAuthorityName = '';
      form.preferredName = '';
      form.occupier = '';
    }
  } catch (err) {
    console.error('Submission error:', err)
    alert('Failed to assign Approval Authority MDA: ' + (err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || err.message))
  }
}

onMounted( () => {
  fetchMDAs(),
  fetchApprovalAuthorities(),
  fetchOccupiers(),
  document.title = "Assign Approval Authority"
})

</script>
